module.exports = __webpack_public_path__ + "static/img/modal.b2b8a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modal.png
// module id = hquj
// module chunks = 89